import React, { useEffect } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import {
  FaBullseye,
  FaEye,
  FaHandshake,
  FaLightbulb,
  FaMapMarkerAlt,
  FaPhoneAlt,
  FaEnvelope
} from "react-icons/fa";
import { Link } from "react-router-dom";
import Navbar from "../../components/Navbar/Navbar"; // <-- your default Navbar
import Footer from "../../components/Footer/Footer"; // <-- your default Footer
import Contact from "../../components/Contact/Contact";
import "./AboutPage.css";

export default function AboutPage() {
  useEffect(() => {
    AOS.init({ duration: 1000, once: true });
  }, []);

  return (
    <>
      {/* Default Navbar */}
      <Navbar />

      <div className="about-section">
        {/* BANNER */}
        <div className="about-banner crimson-bg" data-aos="fade-down">
          <div className="container banner-content">
            <nav className="breadcrumb">
              <div className="container">
                <Link to="/">Home</Link> / <span>About Us</span>
              </div>
            </nav>
          </div>
        </div>

        {/* ABOUT CONTENT */}
        <section className="about-container container">
          <div className="about-text" data-aos="fade-right">
            <h3><strong>About Us</strong></h3><br />
            <div className="story-box crimson-border">
              <h4 className="crimson-text">ABCD International Family</h4>
              <p>
                Founded with the vision <strong>“To reduce failure and bring success and happiness in 
                people’s lives worldwide”</strong>, ABCD International Family stands as a global leader in 
                corporate and business training. Our mission is to help people grow in every aspect of 
                life and business through impactful learning experiences.<br /><br />
                We are proud holders of <strong>11 world records</strong> and have built a strong network of national and 
                international trainers and coaches from multiple countries. Our services include <strong>high-impact 
                corporate training, leadership coaching, business growth programs, personal development 
                workshops, and specialized events</strong> — delivered through both online and offline platforms.<br /><br />
                Our Family is more than a training company — it is a movement to empower, educate, and inspire 
                change at a global scale. Whether you’re an individual seeking personal growth, a business aiming for higher 
                performance, or an organization striving for leadership excellence, we are your partner in transformation.
              </p>

              <h4 className="crimson-text">Interesting Facts</h4>
              <ul>
                <li>300+ webinars and 50+ summits conducted</li>
                <li>10,000+ people impacted globally</li>
                <li>Strategic goal to impact 1 million lives in the next 5 years</li>
                <li>Trusted by individuals, corporates, and institutions worldwide</li>
              </ul>

              <button
                className="btn-get-started"
                onClick={() =>
                  window.open(
                    "https://www.instagram.com/abcdinternationalfamily?igsh=MXZqY2syc2NtOTd4eg==",
                    "_blank"
                  )
                }
              >
                <i className="bi bi-instagram"></i> Visit Us
              </button>

              {/*<Link to="src\pages\Slides\Slides.jsx">
                <button style={{ marginLeft: "10px" }}>Go to Slides</button>
              </Link>*/}
            </div>
          </div>

          <div className="about-image" data-aos="fade-left">
            <img src="/assets/img/logo.jpeg" alt="About" />
          </div>

        </section>

        <section className="about-container container">
          <div className="about-text" data-aos="fade-right">
            <div className="story-box crimson-border">
              <h4 className="crimson-text">About CEO</h4>
              <p>
                Mr. Aakash Bhabad is a young, dynamic, and accomplished leader
                with <strong>11 world records</strong>. As CEO of{" "}
                <strong>ABCD International Family</strong>, Bhabad Films, and
                Bhabad International Publication, he has authored{" "}
                <strong>6 books</strong>—two of which ranked as{" "}
                <strong>#1 Amazon Bestsellers</strong>—and has been featured in
                over <strong>100+ media platforms</strong>. He mentors Trainers,
                Coaches, and Mentors from <strong>15+ countries</strong> and
                organizes International Business Summits worldwide. Recently, he
                entered the film industry as an Actor and Producer, aiming for yet
                another world record.
              </p>

              <h4 className="crimson-text">Interesting Facts</h4>
              <ul>
                <li>11 World Records Holder</li>
                <li>6 Published Books (2 Amazon #1 Bestsellers)</li>
                <li>Mentored authors from 15+ countries</li>
                <li>Featured in 100+ newspapers & media platforms</li>
                <li>Actor & Producer in Hindi Film Industry</li>
                <li>Business & Life Coach with 2000+ success stories</li>
              </ul>
            </div>
          </div>

          <div className="about-image" data-aos="fade-left">
            <img src="/assets/img/IMG-20230117-WA0031.jpg" alt="About" />
          </div>

        </section>

        {/* CONTACT SECTION */}
        <Contact />
      </div>

      {/* Default Footer */}
      <Footer />
    </>
  );
}
